export default "__VITE_ASSET__C51uSia2__"